import UserChallenge from '@/components/challenge/UserChallenge/UserChallenge';
import React from 'react';

const MyChallenge: React.FC = () => <UserChallenge />;

export default MyChallenge;
